import React from 'react';
import { Route, Routes } from 'react-router-dom';

// Types.
import InstanceTarget from '../../types/instance/InstanceTarget';
import HostTarget from '../../types/host/HostTarget';

// Views.
import List from './List';
import Detail from './Detail';
import AvailabilityGroup from './AvailabilityGroup';
import NotFound from '../NotFound';

interface IClustersProps {
    instances: InstanceTarget[],
    hosts: HostTarget[],
    toggleMenu: Function
}

const Clusters: React.FC<IClustersProps> = (props) => {
    const { hosts, toggleMenu } = props;

    return (
        <Routes>
            <Route path="/"
                   element={<List toggleMenu={toggleMenu}/>} />

            <Route path="/:clusterId"
                   element={<Detail hosts={hosts} toggleMenu={toggleMenu}/>} />

            <Route path="/:clusterId/availability-groups/:groupId"
                   element={<AvailabilityGroup toggleMenu={toggleMenu}/>} />

            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default Clusters;
